import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
/* eslint-disable @nx/enforce-module-boundaries */
import { SonaSpinnerComponent } from '@sona/angular-ui-components';
import { Dialog, HlmDialogHeaderComponent, HlmDialogOptions, HlmDialogTitleDirective } from '@spartan-ng/ui-dialog-helm';
/* eslint-enable @nx/enforce-module-boundaries */

@Component({
    imports: [
        SonaSpinnerComponent,
        HlmDialogHeaderComponent,
        HlmDialogTitleDirective,
        TranslatePipe
    ],
    template: `
        <hlm-dialog-header>
            <h1 hlmDialogTitle>
                {{ 'AUTH.DOMAIN.DIALOG.SWITCHING_ORGANIZATION.TITLE' | translate }}
            </h1>
        </hlm-dialog-header>
        <sona-spinner size="sm" />
    `,
    host: {
        class: 'tw-grid tw-place-items-center tw-gap-8 tw-p-6 tw-pt-2'
    }
})
export class SwitchingOrganizationDialog extends Dialog {

    static override readonly baseOptions: Partial<HlmDialogOptions> = {
        backdropClass: 'tw-bg-muted',
        disableClose: true,
        closeOnBackdropClick: false
    };
}
